import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../Services/Users.service';

@Component({
  selector: 'app-idp-landing',
  templateUrl: './idp-landing.component.html',
  styleUrls: ['./idp-landing.component.css']
})
export class IdpLandingComponent implements OnInit {
  communityId: any;

  constructor(private router:Router,private route:ActivatedRoute,private userService:UserService,private cookieService:CookieService,private translate:TranslateService) { }

  ngOnInit() {
    this.communityId = this.route.snapshot.paramMap.get('id');
    // alert(this.communityId);
    console.log(this.communityId);
  }

  getSSOInfo(){
    // alert(this.communityId);
    let obj = {
      comm_id: this.communityId,
    }
    this.userService.getRegisterDatafromCommunityID(obj)
      .subscribe(res => {
        window.location.href = window.location.origin + "/login?token=" + res.data.loginUrl; 
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/idp-landing/idp-landing.component.ts